// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_b7-3";
export var contentContainer = "_b7-0";
export var editorContainer = "_b7-1";
export var quillInputForm = "_b7-2";
export var zoneDivider = "_b7-4";